import React from "react";
import styles from "accountOwner/pages/Appointments/Appointments.module.scss";
import Text from "components/Text";
import crossIcon from "assets/images/new_cross.svg";
import userDefaultImage from "assets/images/staff-default-rounded.png";

export default function InviteesPopup({
  handleInvitePopupToggle,
  position,
  list,
  officeName,
  showRoleAndOffice,
  isForEvent = false,
  onlyOfffice = false,
  isfromBusySlot = false,
  parentClass = "",
  listClass = "",
}) {
  return (
    <div
      className={`${styles.schedular_popup_invite_view} ${parentClass ? parentClass : ""} ${
        isForEvent ? "w-100" : ""
      }`}
      style={{
        top: position?.top,
        right: position?.right,
        position: "absolute",
        zIndex: "99",
      }}
      data-view="listing"
    >
      <span
        className={styles.close_btn_invitess}
        onClick={handleInvitePopupToggle}
      >
        <img src={crossIcon} alt="close" />
      </span>

      <div
        className={
          styles.invitees_data_container + " " + (listClass ? listClass : "")
        }
        style={{ maxHeight: list?.length > 3 ? "300px" : "124px" }}
      >
        {list?.length &&
          list?.map((val) => (
            <div className={styles.container_box} key={val?.id}>
              {!isfromBusySlot && (
                <img
                  src={
                    (onlyOfffice
                      ? val?.officeImage
                      : val?.user?.profilePic ||
                        val?.employee?.user?.profilePic ||
                        val?.profilePic) ||
                    require("assets/images/default-image.svg").default
                  }
                  alt="DummyImg"
                  className={styles.invitees_img}
                  onError={(e) => {
                    e.currentTarget.src = userDefaultImage;
                  }}
                />
              )}
              <div>
                <Text
                  size="14px"
                  weight="500"
                  color="#102C42"
                  lineHeight="14px"
                >
                  {onlyOfffice
                    ? val?.name
                      ? val?.name
                      : val?.office?.name
                    : val?.user?.fullName ||
                      val?.userName ||
                      val?.employee?.user?.fullName ||
                      [
                        val?.user?.firstName || val?.employee?.user?.firstName,
                        val?.user?.lastName || val?.employee?.user?.lastName,
                      ]
                        .filter(Boolean)
                        .join(" ")}
                </Text>
                {!onlyOfffice && (
                  <Text size="12px" weight="400" color="#87928D">
                    {officeName}
                  </Text>
                )}
                {showRoleAndOffice && (
                  <Text size="12px" weight="400" color="#87928D">
                    {`${
                      val?.designation?.name || val?.employee?.designation?.name
                        ? (val.designation.name ||
                            val?.employee?.designation?.name) + ", "
                        : ""
                    }${val?.office?.name || val?.employee?.office?.name || ""}`}
                  </Text>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
